import AppConstants from "AppConstants";
import { Component } from "react";
import { connect } from "react-redux";
import { AppState } from "types/app";
import utils from "util/utils";
import app_menu from "views/page-parts/app-menu/items";
import MenuFooter from "views/page-parts/app-menu/MenuFooter";
import MenuHeader from "views/page-parts/app-menu/MenuHeader";
import MenuItem from "views/page-parts/app-menu/MenuItem";
import { MenuItemOptions, MenuItemWithSubMenu, MenuItemWithView, ViewMenuProps } from "views/page-parts/app-menu/types";
import "./Menu.css";

const mapStateToProps = (state:AppState) => {
	return {
		lang: state.userInfo.options.lang,
		gameLang: state.userInfo.options.gameLang,
	};
};

class Menu extends Component<ViewMenuProps> {
	private nextMenuID = 1;
	constructor(props:ViewMenuProps){
		super(props);
		this.attachIDsToMenu(app_menu);
	}

	render():JSX.Element{
		return (
			<div id="menu" className="hide">
				<MenuHeader />
				<div className="menu-wrapper">
					{app_menu.map((menu:MenuItemWithView|MenuItemWithSubMenu) => {
						const options:MenuItemOptions = {
							background: "primary",
							menuItemView: this.hasSubMenu(menu) ? false as false : menu.view,
							submenu: this.hasSubMenu(menu) ? menu.submenu : false as false,
							headers: [menu.header],
						};

						return (
							<MenuItem key={`menu_${menu.header}_${menu.id}`} options={options} />
						);
					})}
				</div>
				<MenuFooter />
			</div>
		);
	}

	componentDidMount(){
		const vw = utils.helpers.getWindowWidth();
		if(vw > AppConstants.TabletWidth){
			const menu = document.getElementById("menu");
			if(menu){ menu.classList.remove("hide"); }
		}

		const menuItem = document.querySelector<HTMLDivElement>(".menu-item.selected");
		if(menuItem){
			let parentEle = menuItem.closest(".sub-menu");
			let nextParentSelector = ".menu-item";
			while(parentEle){
				parentEle.classList.add("open");
				parentEle = parentEle.closest(nextParentSelector);

				if(nextParentSelector === ".menu-item"){
					nextParentSelector = ".sub-menu";
				}else{
					nextParentSelector = ".menu-item";
				}
			}
		}
	}

	private hasSubMenu(menuItem:MenuItemWithView|MenuItemWithSubMenu): menuItem is MenuItemWithSubMenu{
		if(typeof (menuItem as MenuItemWithSubMenu).submenu === "undefined"){
			return false;
		}
		return true;
	}

	attachIDsToMenu(menu:(MenuItemWithView | MenuItemWithSubMenu)[]){
		menu.forEach((item) => {
			item.id = this.nextMenuID++;
			if(this.hasSubMenu(item)){ this.attachIDsToMenu(item.submenu); }
		});
	}
}
export default connect(mapStateToProps)(Menu);
